import { ReactNode } from "react";

const PageContainer = ({ children, showOverlay = true }: { children: ReactNode; showOverlay?: boolean }) => {
  if (!showOverlay) return <div>{children}</div>;
  return (
    <div className="relative after:absolute after:w-full after:h-full after:top-0 after:left-0 after:bg-white/40 after:backdrop-blur-[3px] sm:after:backdrop-blur-[7px]">
      <div className="absolute z-20 flex flex-col items-center mt-32 md:mt-0 md:justify-center w-full h-full text-gray-800 p-4">
        <div className="sm:px-6 md:px-8 lg:px-20 text-sm sm:text-base md:text-lg lg:text-xl text-center space-y-3 sm:space-y-4 max-w-4xl">
          <p className="font-medium leading-relaxed">
            Once there's an active opening matching your profile, this section will unlock automatically. You'll find
            all the assessments you need to smoothly manage your role and seamlessly integrate with your organization.
          </p>
          <p className="mt-3 sm:mt-4 font-medium text-indigo-500">Stay tuned—your next opportunity awaits! 🚀</p>
        </div>
      </div>
      {children}
    </div>
  );
};

export default PageContainer;
